<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'Gallery'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="14"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Gallery</div>
            <viewer :options="options" :images="images"
                    @inited="inited"
                    class="viewer" ref="viewer">
              <template #default="scope">
                <div class="container grid grid-cols-4 gap-2 mx-auto">
                  <img class="cursor-pointer w-auto h-48 shadow-sm rounded-sm" v-for="image in scope.images"
                       :src="image.url" :key="image" :alt="image.title">
                </div>
                {{ scope.options }}
              </template>
            </viewer>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import KeyRecruiters from "@/components/KeyRecruiters";
import Sidebar from "@/views/academics/mba/Sidebar";
import {component as viewer} from 'v-viewer'
import 'viewerjs/dist/viewer.css'

export default {
  name: "Gallery",
  components: {
    NavbarComponent,KeyRecruiters,
    PageHeader,
    Sidebar,
    FooterComponent,
    viewer
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      images: [
        {title: 'Cricket Team', url: '/static/images/mba/gallery/g1.jpg'},
        {title: 'img 2', url: '/static/images/mba/gallery/g2.jpg'},
        {title: 'img 3', url: '/static/images/mba/gallery/g3.jpg'},
        {title: 'img 4', url: '/static/images/mba/gallery/g4.jpg'},
        {title: 'img 5', url: '/static/images/mba/gallery/g5.jpg'},
        {title: 'img 6', url: '/static/images/mba/gallery/g6.jpg'},
        {title: 'img 7', url: '/static/images/mba/gallery/g7.jpg'},
        {title: 'img 8', url: '/static/images/mba/gallery/g9.jpg'},
        {title: 'img 9', url: '/static/images/mba/gallery/g8.jpg'},
      ],
      index: null,
    }
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer
    },
    show() {
      this.$viewer.show()
    }
  },
}
</script>
<style lang="scss" scoped/>
